module.exports = __webpack_public_path__ + "static/img/アセット 9@3x.e51a482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 9@3x.png
// module id = U6hK
// module chunks = 1